import React from "react";

import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import { IconButton, Stack, Typography } from "@mui/material";

import { useEmailsContext } from "../context/Email-context";

interface Props {}

export const Pagination: React.FC<Props> = () => {
  const { pagination, setPagination } = useEmailsContext();
  const { page, per_page, total } = pagination;
  const from = (page - 1) * per_page + 1;
  const to = Math.min(page * per_page, total);

  const onPageChange = (newPage: number) => {
    setPagination((prev) => ({ ...prev, page: newPage }));
  };

  return (
    <Stack direction="row" alignItems="center" justifyContent="space-between">
      <Stack direction="row" alignItems="center" gap="10px">
        <Typography
          sx={{ fontSize: "12px", fontWeight: 400, minWidth: "70px" }}
        >{`${from}-${to} of ${total}`}</Typography>
        <IconButton disabled={page === 1} onClick={() => onPageChange(page - 1)}>
          <ArrowBackIosNewIcon sx={{ fontSize: "10px !important" }} />
        </IconButton>
        <IconButton disabled={to === total} onClick={() => onPageChange(page + 1)}>
          <ArrowForwardIosIcon sx={{ fontSize: "10px !important" }} />
        </IconButton>
      </Stack>
    </Stack>
  );
};
